import { HTMLAttributes } from 'react';

import { styled } from 'netline-ui';
import { Json, JsonPrimitive } from 'types';

import JsonItem from './JsonItem';
import styles, { jsonViewerClasses } from './JsonViewer.styles';

type JsonViewerProps<Primitives extends unknown = JsonPrimitive> = HTMLAttributes<HTMLDivElement> & {
  json: Json<Primitives>;
};

const JsonViewerRoot = styled('div', { name: jsonViewerClasses.$name })(styles);

const JsonViewer = <Primitives extends unknown = JsonPrimitive>({ json, ...props }: JsonViewerProps<Primitives>) => {
  return (
    <JsonViewerRoot {...props}>
      <JsonItem json={json} />
    </JsonViewerRoot>
  );
};

export default JsonViewer;
